module.exports = __webpack_public_path__ + "images/8ca3af40ebbf91dae28b8435c9dc39b0.jpg";